<template lang="pug">
  #friends
    WtTile(ancestor vertical)
      BLoading(:active.sync="fullPageLoader" :is-full-page="true")
      template(v-if="usernameNotFound")
        WtTile(child)
          WtTitle(h1) User does not exist, return to your&nbsp
            span
              RouterLink(:to="{ name: 'MyDashboard' }") dashboard.
      template(v-else)
        WtTile(parent)
          .friends-header.level.is-mobile.is-custom-mobile
            .level-left
              .level-item
                WtTitle(h1) {{ routeUsername }}'s Friends

        WtTile(parent vertical)
          section.section.empty-state(v-if="isFriendsFeatureOn && _.isEmpty(memberFriends)")
          MyFriends(v-else-if="isFriendsFeatureOn && friendsLoaded" :memberFriends="memberFriends")
          template(v-else-if="friendsLoaded")
            WtTile(child)
              WtTitle(h1) {{ routeUsername }} has hidden their friends, return to your&nbsp
                span
                  RouterLink(:to="{ name: 'MyDashboard' }") dashboard.

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import MyFriends from "@@/Friends/ProfileMyFriends";
import { fetchAllMixin } from "@/mixins/fetchAllMixin";

export default {
  name: "ProfileFriends",

  components: {
    WtTile,
    WtTitle,
    MyFriends
  },

  mixins: [fetchAllMixin],

  data() {
    return {
      page: "ProfileFriends",
      member: {},
      memberFriends: [],
      friendsLoaded: false,
      isFriendsFeatureOn: false,
      usernameNotFound: false
    };
  },

  computed: {
    ...mapGetters("pages", ["isPageLoading"]),
    ...mapGetters("members", [
      "getMemberByName",
      "getFriendsByMemberId",
      "friendsLoadedByMemberId"
    ]),

    routeUsername() {
      return this.$route.params.username;
    },

    fullPageLoader() {
      // since there is no intial state for 'isPageLoading(this.page)'
      if (this._.isUndefined(this.isPageLoading(this.page))) {
        return true;
      }
      return this.isPageLoading(this.page);
    }
  },

  async mounted() {
    await this.toFetchOrNotToFetch(this, this.page, {
      force: !this.isPageLoading(this.page)
    });
  },

  methods: {
    ...mapActions("members", ["fetchMember", "fetchFriends"]),

    async fetchAllPage(vm) {
      try {
        vm.member = await vm.fetchMember({
          memberId: vm.routeUsername,
          setMemberByName: true
        });
        const memberId = vm.member.id;
        vm.isFriendsFeatureOn =
          this._.get(vm.member, "memberData.friendsViewable", "No") === "Yes";
        if (vm.isFriendsFeatureOn) {
          await this.fetchFriends({ memberId: memberId });
          vm.memberFriends = vm.getFriendsByMemberId(memberId);
          vm.friendsLoaded = vm.friendsLoadedByMemberId(memberId);
        } else {
          vm.friendsLoaded = true;
        }
      } catch (error) {
        vm.usernameNotFound = true;
      }
    }
  }
};
</script>

<style lang="sass" scoped>
#friends
  .my-friends
    min-height: 425px
  .find-new-friends
    max-height: 425px
    min-height: 425px
  .friends-header
    width: 100%
  .is-custom-mobile
    @media screen and (max-width: 480px)
      flex-direction: column
      align-items: flex-start
    .level-right
      @media screen and (max-width: 480px)
        margin: 1rem 0 !important
</style>
